const showSubfunc = (value, units, showSeparator = true) => value ? (showSeparator ? `${value} ${units}, ` : `${value} ${units}`) : '';

export const DDhhmmss = inputSeconds => {
  const tsec = Math.floor(inputSeconds);
  let minutes = Math.floor(tsec / 60);
  const secs = tsec % 60;
  let hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  const days = Math.floor(hours / 24);
  hours = hours % 24;
  return `${showSubfunc(days, 'd')}${showSubfunc(hours, 'hr')}${showSubfunc(minutes, 'm')}${showSubfunc(secs, 's', false)} (${tsec} s)`;
};




// WEBPACK FOOTER //
// ./src/utils/helper.js